import { Total } from 'graphql-api/baskets-api-interfaces';

export function getSimulatedTotal(
  total: Total,
  hasManualDiscountApplied: boolean,
) {
  return hasManualDiscountApplied
    ? total?.simulated?.net
    : total.confirmed?.net;
}
